import { PagedView } from './dictionary';
import request from '../utils/request';
import { basePaymentApiUrl } from '../constants';

export function fetchPaymentDetails(data: any): Promise<PagedView<any>> {
    return request({
        url: '/payment/get-sign-asset',
        data: {
            ...data,
        },
        method: 'POST',
        baseURL: basePaymentApiUrl,
    }).then(({ data }) => data as PagedView<any>);
}
